var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#CEEBEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8223 32.9645L29.9479 29.09C33.0806 25.5159 32.9423 20.0743 29.533 16.665C25.9796 13.1117 20.2184 13.1117 16.665 16.665C13.1117 20.2184 13.1117 25.9796 16.665 29.533C20.0743 32.9423 25.5159 33.0806 29.09 29.9479L32.9645 33.8223C33.2014 34.0592 33.5854 34.0592 33.8223 33.8223C34.0592 33.5854 34.0592 33.2014 33.8223 32.9645ZM28.6751 17.5229C31.7547 20.6025 31.7547 25.5955 28.6751 28.6751C25.5955 31.7547 20.6025 31.7547 17.5229 28.6751C14.4433 25.5955 14.4433 20.6025 17.5229 17.5229C20.6025 14.4433 25.5955 14.4433 28.6751 17.5229Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBtn);
export default __webpack_public_path__ + "static/media/search-btn.d5f9c3c07dcb3d5c750f59bd3a276bf0.svg";
export { ForwardRef as ReactComponent };